import { render, staticRenderFns } from "./service-group.vue?vue&type=template&id=3ac7d4d6&scoped=true&"
import script from "./service-group.vue?vue&type=script&lang=js&"
export * from "./service-group.vue?vue&type=script&lang=js&"
import style0 from "./service-group.vue?vue&type=style&index=0&id=3ac7d4d6&lang=less&scoped=true&"
import style1 from "./service-group.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac7d4d6",
  null
  
)

export default component.exports